module.exports = __webpack_public_path__ + "img/horbach_3_1_w1000.8a5bbf62.webp";